import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    BooleanInput,
    SaveButton,
    Toolbar,
} from 'react-admin';
import { required } from 'react-admin';
import { Grid, Typography } from '@mui/material';

const CreateToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);

const MaterialstorageCreate = () => (
    <Create>
        <SimpleForm toolbar={<CreateToolbar />}>
            <Grid container width={{ xs: '100%' }} spacing={2}>
                <Grid size={{ xs: 12, md: 8 }}>
                    <TextInput
                        source="name"
                        validate={[required()]}
                        fullWidth
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <TextInput
                        source="path"
                        validate={[required()]}
                        fullWidth
                    />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
                        Asetukset
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <BooleanInput source="public.sso" defaultValue={false} />
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <BooleanInput
                        source="public.redirtoken"
                        defaultValue={false}
                    />
                </Grid>
            </Grid>
        </SimpleForm>
    </Create>
);

export default MaterialstorageCreate;
